import { cn } from '../../lib/utils';
import { VariantProps, cva } from 'class-variance-authority';
import { ButtonHTMLAttributes } from 'react';

const buttonStyles = cva(
  'flex items-center bg-primary text-white justify-center py-[10px] px-[25px] rounded-[5px] font-medium focus:outline-none disabled:opacity-60 disabled:pointer-events-none min-w-[98px] min-h-[41px] leading-5',
  {
    variants: {
      /**
       * Outlined button
       */
      outline: {
        true: 'border border-neutral-100 bg-white text-black',
      },
      redOutline: {
        true: 'border border-primary bg-white text-black',
      },
      /**
       * Optional rounded corners
       */
      rounded: {
        true: 'rounded-full',
      },
      gradient: {
        true: 'h-[58px] w-full rounded-[40px] bg-gradient-to-r from-[#F5375C] to-[#C33076] align-baseline text-h5 font-semibold text-white 2xl:h-[68px] hover:text-primary hover:bg-none hover:bg-white hover:border-2 hover:border-primary',
      },
    },
    defaultVariants: {},
  }
);

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonStyles> {
  /**
   * Optional extra class that will take precedence over the default styles.
   */
  className?: string;
  // label: string;
}

/**
 * Primary Button
 */
const Button = ({
  className,
  outline,
  rounded,
  gradient,
  redOutline,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={cn(
        buttonStyles({ rounded, outline, gradient, redOutline, className })
      )}
      {...props}
    />
  );
};

export default Button;
